import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';

import Accordion from 'app/ui/accordion';
import EntryPaneUI from 'contest/ui/entry-pane';
import EntryPaneData from 'contest/data/entry-pane';
import EliminateDesignerModalUI from 'contest/ui/eliminate-designer-modal';
import entriesApp from 'contest/apps/entries';
import { PollsTabOnboardingPrompt } from 'contest/components/onboarding-prompts';
import app from 'contest/data/app';
import ActiveUserFlagStore from 'contest/stores/active-user-flag-store';
import ContestStore from 'contest/stores/contest-store';
import OnboardingPromptStore from 'contest/stores/onboarding-prompt-store';
import ContestsActiveUserStore from 'contest/stores/ContestsActiveUserStore';

$(function() {
    const entriesNode = document.querySelector('[data-entries-app]');
    if (entriesNode) {
        const state = JSON.parse(entriesNode.dataset.state);
        const intl = JSON.parse(entriesNode.dataset.intl);
        const context = entriesApp(entriesNode, state, intl);
        EntryPaneUI.attachTo('body', { context, intl });
    } else {
        EntryPaneUI.attachTo('body', { context: null, intl: null });
    }

    EntryPaneData.attachTo('body', { designPaneEndPoint: window.designPaneEndPoint });

    EliminateDesignerModalUI.attachTo('[data-eliminate-designer-modal]');

    Accordion.attachTo('[data-accordion]');

    const pollsTab = document.querySelector('[data-polls-tab]');

    if (pollsTab && window.activeUser && window.activeUser.role === 'owner') {
        app.registerStore(ActiveUserFlagStore);
        app.registerStore(ContestStore);
        app.registerStore(OnboardingPromptStore);
        app.registerStore(ContestsActiveUserStore);

        const context = app.getContext();
        context.getStore(ActiveUserFlagStore).initFromActiveUser(window.activeUser);
        context
            .getStore(ContestStore)
            .init(JSON.parse(document.querySelector('[data-contest-state]').dataset.contestState));

        if (pollsTab) {
            const pollsTabData = JSON.parse(pollsTab.getAttribute('data-polls-tab'));
            const intlData = pollsTabData.intl;
            const count = pollsTabData.count;
            const onboardingPromptActive = pollsTabData.onboardingPromptActive;

            ReactDOM.render(
                <FluxibleComponent context={context.getComponentContext()}>
                    <IntlProvider
                        locale={document.documentElement.lang}
                        messages={intlData.messages}
                    >
                        <span>
                            {onboardingPromptActive ? (
                                <PollsTabOnboardingPrompt>
                                    <span className="tab-nav__item__title">
                                        <FormattedMessage id="polls" />
                                    </span>
                                </PollsTabOnboardingPrompt>
                            ) : (
                                <span className="tab-nav__item__title">
                                    <FormattedMessage id="polls" />
                                </span>
                            )}
                            {count > 0 && <span className="tab-nav__item__count">({count})</span>}
                        </span>
                    </IntlProvider>
                </FluxibleComponent>,
                pollsTab
            );
        }
    }
});



// WEBPACK FOOTER //
// ./src/web/js/contest/entries.js